import type { ApiResponse } from "@/types";

import { BaseApi } from "../base.api";
import type { Assignment, CreateAssignmentData, UpdateAssignmentData } from "./types";

export * from "./types";

/** Topshiriqlar API — backend'dagi `AssignmentsController` ning ko'zgusi. */
export class AssignmentsApi extends BaseApi {
  private readonly baseUrl = "/assignments";

  /** Hali topshiriq bo'lmasa 404 — kutilgan holat, toast ko'rsatilmaydi. */
  getByLesson(lessonId: number) {
    return this.request.get<Assignment, ApiResponse<Assignment>>(
      `${this.baseUrl}/lesson/${lessonId}`,
      { skipErrorToast: true },
    );
  }

  create(data: CreateAssignmentData) {
    return this.request.post<Assignment, ApiResponse<Assignment>>(this.baseUrl, data);
  }

  update(id: number, data: UpdateAssignmentData) {
    return this.request.patch<Assignment, ApiResponse<Assignment>>(`${this.baseUrl}/${id}`, data);
  }

  remove(id: number) {
    return this.request.delete<null, ApiResponse<null>>(`${this.baseUrl}/${id}`);
  }

  addAttachments(id: number, files: File[], onProgress?: (percent: number) => void) {
    const formData = new FormData();
    files.forEach(file => formData.append("files", file));
    return this.request.post<Assignment, ApiResponse<Assignment>>(
      `${this.baseUrl}/${id}/attachments`,
      formData,
      {
        onUploadProgress: event => {
          if (onProgress && event.total) {
            onProgress(Math.round((event.loaded * 100) / event.total));
          }
        },
      },
    );
  }
}

export const assignmentsApi = new AssignmentsApi();
